import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import MentionedIn from './components/MentionedIn';
import ThreePillars from './components/ThreePillars';
import FeatureGrid from './components/FeatureGrid';
import PricingPreview from './components/PricingPreview';
import Comparison from './components/Comparison';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import PricingPage from './pages/PricingPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookieBanner from './components/CookieBanner';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './pages/admin/AdminProtectedRoute';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverview from './pages/admin/AdminOverview';
import AdminClients from './pages/admin/AdminClients';
import AdminAddClient from './pages/admin/AdminAddClient';
import AdminApprovals from './pages/admin/AdminApprovals';
import AdminAudits from './pages/admin/AdminAudits';
import AdminSettings from './pages/admin/AdminSettings';
import { PortalAuthProvider } from './context/PortalAuthContext';
import PortalProtectedRoute from './pages/portal/PortalProtectedRoute';
import PortalLogin from './pages/portal/PortalLogin';
import PortalAuthCallback from './pages/portal/PortalAuthCallback';
import PortalLayout from './pages/portal/PortalLayout';
import PortalOverview from './pages/portal/PortalOverview';
import PortalAudits from './pages/portal/PortalAudits';
import PortalApprovals from './pages/portal/PortalApprovals';

const Home = () => (
  <div className="min-h-screen bg-[#FFFBF5]">
    <Header />
    <main>
      <Hero />
      <MentionedIn />
      <ThreePillars />
      <FeatureGrid />
      <PricingPreview />
      <Comparison />
      <FAQ />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
        <PortalAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />

            <Route path="/login" element={<PortalLogin />} />
            <Route path="/portal/auth-callback" element={<PortalAuthCallback />} />
            <Route
              path="/portal"
              element={
                <PortalProtectedRoute>
                  <PortalLayout />
                </PortalProtectedRoute>
              }
            >
              <Route index element={<PortalOverview />} />
              <Route path="audits" element={<PortalAudits />} />
              <Route path="approvals" element={<PortalApprovals />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
            >
              <Route index element={<AdminOverview />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="clients/new" element={<AdminAddClient />} />
              <Route path="approvals" element={<AdminApprovals />} />
              <Route path="audits" element={<AdminAudits />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <CookieBanner />
        </PortalAuthProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
